import React, { useEffect, useMemo, useState } from 'react'
import MasterService from '../../../../services/master/MasterService'
import Kemasan from '../../../../utilities/Kemasan'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { FaArrowLeft, FaChevronCircleLeft, FaEdit, FaEye, FaPlus, FaSave, FaTrash } from 'react-icons/fa'
import DataTable from 'react-data-table-component'
import NonlalinService from '../../../../services/nonlalin/NonlalinService'
import SweetAlert from 'react-bootstrap-sweetalert'
import { AsyncPaginate } from 'react-select-async-paginate'

const ViewNonLalinKemasan = ({ dataKemasan, saveKemasan, cancelKemasan }) => {
    const [showAddKemasan, setShowAddKemasan] = useState(false);
    const handleCloseAddKemasan = () => setShowAddKemasan(false);
    const handleShowAddKemasan = () => {
        setValueSeri(0)
        setShowAddKemasan(true)
    }

    const [showEditKemasan, setShowEditKemasan] = useState(false);
    const handleCloseEditKemasan = () => setShowEditKemasan(false);
    const handleShowEditKemasan = async (row) => {
        // console.log(row)
        // setDetilKemasan(row)
        setValueSeri(row.trNonlalinKemasanPK.seri)
        const resKemasan = await masterService.getKemasanById(row.kodeKemasan)
        setValueKemasanOpt(resKemasan.data)
        setValueKodeKemasan(row.kodeKemasan)
        setValueMerkKemasan(row.merk)
        setValueJumlahKemasan(row.jumlah)
        setShowEditKemasan(true)
    }

    const [showViewKemasan, setShowViewKemasan] = useState(false);
    const handleCloseViewKemasan = () => setShowViewKemasan(false);
    const handleShowViewKemasan = (row) => {
        setDetilKemasan(row)
        setShowViewKemasan(true)
    }

    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const handleCloseConfirmDelete = () => setShowConfirmDelete(false)
    const handleShowConfirmDelete = (row) => {
        setDetilKemasan(row)
        setShowConfirmDelete(true)
    }
    const [showDeleteSuccess, setShowDeleteSuccess] = useState(false)
    const [showDeleteFailed, setShowDeleteFailed] = useState(false)

    const [detilKemasan, setDetilKemasan] = useState(null)

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleShowConfirmSave = () => setShowConfirmSave(true)

    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)

    const [countKms, setCountKms] = useState(0)

    const [valueSeri, setValueSeri] = useState(0)
    const [valueKemasanOpt, setValueKemasanOpt] = useState(null)
    const [valueKodeKemasan, setValueKodeKemasan] = useState(null)
    const [valueMerkKemasan, setValueMerkKemasan] = useState(null)
    const [valueJumlahKemasan, setValueJumlahKemasan] = useState(null)

    const columns = [
        {
            name: 'Seri',
            cell: row => row['trNonlalinKemasanPK'].seri,
            grow: 0
        },
        {
            name: 'Kode Kemasan',
            cell: row => (<>{row['kodeKemasan']} - &nbsp;<Kemasan id={row['kodeKemasan']} /></>)
        },
        {
            name: 'Nomor PO',
            cell: row => row['merk']
        },
        {
            name: 'Jumlah',
            cell: row => row['jumlah']
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        <div className='col-sm-3'>
                            <Button size='sm' variant='info' onClick={() => handleShowViewKemasan(row)}>
                                <FaEye />
                            </Button>
                        </div>
                        {localStorage.getItem('isEditStorage') === '1' ?
                            <>
                                <div className='col-sm-3'>
                                    <Button size='sm' variant='warning' onClick={() => handleShowEditKemasan(row)}>
                                        <FaEdit />
                                    </Button>
                                </div>
                                <div className='col-sm-3'>
                                    <Button size='sm' variant='danger' onClick={() => handleShowConfirmDelete(row)}>
                                        <FaTrash />
                                    </Button>
                                </div>
                            </> : ''
                        }
                    </div>
                </>
            )
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])
    // let transaksiService = useMemo(() => new TransaksiService(), [])
    let nonLalinService = useMemo(() => new NonlalinService(), [])

    const [listDataKemasan, setListDataKemasan] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!dataKemasan) return;
        setLoading(true)
        setListDataKemasan(dataKemasan.data)
        setLoading(false)
    }, [dataKemasan])

    async function loadOptionJenisKemasanOpt(search, loadedOption, { page = 1 }) {
        const response = await masterService.listKemasan(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangeJenisKemasanOpt = e => {
        setValueKemasanOpt(e)
        setValueKodeKemasan(e.kodeKemasan)
    }

    const onChangeMerkKemasan = e => {
        setValueMerkKemasan(e.target.value)
    }

    const onChangeJumlahKemasan = e => {
        setValueJumlahKemasan(e.target.value)
    }

    const [kelengkapan, setKelengkapan] = useState({})
    const checkKelengkapan = () => {
        const checkKelengkapan = {}
        if (!valueKemasanOpt) checkKelengkapan.jenisKemasan = 'Jenis Kemasan Wajib Diisi'
        if (!valueJumlahKemasan) checkKelengkapan.jumlah = 'Jumlah Kemasan Wajib Diisi'
        if (!valueMerkKemasan) checkKelengkapan.merk = 'Nomor PO Wajib Diisi'

        setKelengkapan(checkKelengkapan)

        return Object.keys(checkKelengkapan).length === 0
    }

    const handleClickSimpan = async () => {
        if (checkKelengkapan()) {
            try {
                // let dataheader = JSON.parse(localStorage.getItem('dataHeaderStorage'))
                let nomorAjuStorage = localStorage.getItem('nomorAjuStorage')
                const resNextSeri = await nonLalinService.nextSeriNonlalin('kms', nomorAjuStorage)
                setLoadingSave(true)
                let jsonDataKemasan = {
                    jumlah: valueJumlahKemasan,
                    kodeKemasan: valueKodeKemasan,
                    merk: valueMerkKemasan,
                    trNonlalinKemasanPK: {
                        nomorAju: nomorAjuStorage,
                        seri: valueSeri !== 0 ? valueSeri : resNextSeri.data
                    }
                }
                const response = await nonLalinService.saveNonlalinKemasan(JSON.stringify(jsonDataKemasan))
                if (response.data.kode === '200') {
                    setShowSaveSucces(true)
                    setShowConfirmSave(false)
                    setListDataKemasan([...listDataKemasan, jsonDataKemasan])
                }
                setLoadingSave(false)
                setCountKms(countKms + 1)
            } catch (error) {
                setLoadingSave(false)
                setShowConfirmSave(false)
                setShowSaveFailed(true)
                // console.log(error)
            }
        } else {
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
    }

    const handleClickSaveSuccess = () => {
        setLoadingSave(false)
        setShowSaveSucces(false)
        setShowAddKemasan(false)
        setShowEditKemasan(false)
        cancelKemasan('kemasan')
        localStorage.setItem('dataKemasanStorage', listDataKemasan)
    }

    const handleClickSaveFailed = () => {
        setLoadingSave(false)
        setShowSaveFailed(false)
    }

    const handleClickDelete = async () => {
        try {
            let jsonData = {
                nomorAju: detilKemasan.trNonlalinKemasanPK.nomorAju,
                seri: detilKemasan.trNonlalinKemasanPK.seri
            }
            const resDelete = await nonLalinService.deleteNonlalinKemasan(jsonData)
            if (resDelete.data.kode === '200') {
                setShowConfirmDelete(false)
                setShowDeleteSuccess(true)
            }
        } catch (error) {
            setShowConfirmDelete(false)
            setShowDeleteFailed(true)
        }
    }

    const handleClickDeleteSuccess = () => {
        setShowDeleteSuccess(false)
        setShowConfirmDelete(false)
        cancelKemasan('kemasan')
        localStorage.setItem('dataKemasanStorage', listDataKemasan)
    }

    const handleClickDeleteFailed = () => {
        setShowDeleteFailed(false)
    }

    return (
        <>
            <div className="form-card text-start">
                <div className="row">
                    <div className="col-7">
                        <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuStorage')} </h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <h5 className="mb-4">Kemasan</h5>
                    </div>
                </div>
                <div className="row">
                    {
                        localStorage.getItem('isEditStorage') === '1' ?
                            <div className="col-7">
                                <Button type="button" variant="primary" size="sm" onClick={handleShowAddKemasan}><FaPlus/> Tambah Kemasan</Button>
                            </div> : ''
                    }
                </div>
            </div>
            <div className="table-responsive border-bottom my-3">
                {(loading && <Spinner />)}
                <DataTable
                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                    columns={columns}
                    data={listDataKemasan}
                    highlightOnHover
                    pagination
                    persistTableHead={true}
                />
            </div>
            {
                localStorage.getItem('isEditStorage') === '1' ? <>
                    <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next" onClick={() => saveKemasan()} ><FaSave /> Simpan & Lanjutkan</button>
                    <button type="button" name="previous" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Previous" onClick={() => cancelKemasan('dokumen')} ><FaArrowLeft /> Sebelumnya</button>
                </> : ''
            }

            <Modal
                show={showAddKemasan}
                onHide={handleCloseAddKemasan}
                backdrop="static"
                keyboard={false}
                size='md'
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Tambah Kemasan</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Kode Kemasan<span className='text-danger'>*</span></label>
                        <div className="col-sm-6">
                            {/* <input type="text" className="form-control-sm" name="kd_kemasan" placeholder="Kode Kemasan" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionJenisKemasanOpt}
                                value={valueKemasanOpt}
                                getOptionLabel={(option) => option.kodeKemasan + ' - ' + option.uraianKemasan}
                                getOptionValue={(option) => option.kodeKemasan}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeJenisKemasanOpt}
                            />
                            {kelengkapan.jenisKemasan && <div className='text-danger'>{kelengkapan.jenisKemasan}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor PO<span className='text-danger'>*</span></label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="merk" placeholder="Nomor PO" value={valueMerkKemasan} onChange={onChangeMerkKemasan} />
                        </div>
                        {kelengkapan.merk && <div className='text-danger'>{kelengkapan.merk}</div>}
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Jumlah<span className='text-danger'>*</span></label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="jumlah" placeholder="Jumlah" value={valueJumlahKemasan} onChange={onChangeJumlahKemasan} />
                        </div>
                        {kelengkapan.jumlah && <div className='text-danger'>{kelengkapan.jumlah}</div>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAddKemasan} size='sm'>
                        <FaChevronCircleLeft /> Close
                    </Button>
                    <Button variant="primary" onClick={handleShowConfirmSave} size='sm'><FaSave /> Simpan</Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showEditKemasan}
                onHide={handleCloseEditKemasan}
                backdrop="static"
                keyboard={false}
                size='md'
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Ubah Kemasan</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Kode Kemasan<span className='text-danger'>*</span></label>
                        <div className="col-sm-6">
                            {/* <input type="text" className="form-control-sm" name="kd_kemasan" placeholder="Kode Kemasan" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionJenisKemasanOpt}
                                value={valueKemasanOpt}
                                getOptionLabel={(option) => option.kodeKemasan + ' - ' + option.uraianKemasan}
                                getOptionValue={(option) => option.kodeKemasan}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeJenisKemasanOpt}
                            />
                            {kelengkapan.jenisKemasan && <div className='text-danger'>{kelengkapan.jenisKemasan}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor PO<span className='text-danger'>*</span></label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="merk" placeholder="Nomor PO" value={valueMerkKemasan} onChange={onChangeMerkKemasan} />
                            {kelengkapan.merk && <div className='text-danger'>{kelengkapan.merk}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Jumlah<span className='text-danger'>*</span></label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="jumlah" placeholder="Jumlah" value={valueJumlahKemasan} onChange={onChangeJumlahKemasan} />
                        </div>
                        {kelengkapan.jumlah && <div className='text-danger'>{kelengkapan.jumlah}</div>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditKemasan} size='sm'>
                        <FaChevronCircleLeft /> Close
                    </Button>
                    <Button variant="primary" onClick={handleShowConfirmSave} size='sm'><FaSave /> Simpan</Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showViewKemasan}
                onHide={handleCloseViewKemasan}
                backdrop="static"
                keyboard={false}
                size='md'
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Lihat Kemasan</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Kemasan</label>
                        <div className="col-sm-6">
                            {/* <input type="text" className="form-control-sm" name="kd_kemasan" placeholder="Kode Kemasan" /> */}
                            {detilKemasan !== null ? <Kemasan id={detilKemasan.kodeKemasan} /> : ''}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor PO</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="merk" placeholder="" value={detilKemasan !== null ? detilKemasan.merk : ''} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Jumlah</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="jumlah" placeholder="Jumlah" value={detilKemasan !== null ? detilKemasan.jumlah : ''} disabled />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseViewKemasan} size='sm'>
                        <FaChevronCircleLeft /> Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data Kemasan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Kemasan Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Kemasan Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmDelete &&
                <SweetAlert
                    title="Hapus Data Kemasan?"
                    warning
                    showCancel
                    confirmBtnText="Hapus"
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickDelete}
                    onCancel={handleCloseConfirmDelete}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >Data Kemasan : {detilKemasan !== null ? <Kemasan id={detilKemasan.kodeKemasan} /> : ''}</SweetAlert>
            }
            {
                showDeleteSuccess &&
                <SweetAlert
                    success
                    title="Hapus Data Kemasan Berhasil"
                    onConfirm={handleClickDeleteSuccess}
                    btnSize="sm"
                />
            }
            {
                showDeleteFailed &&
                <SweetAlert
                    danger
                    title="Hapus Data Kemasan Gagal"
                    onConfirm={handleClickDeleteFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ViewNonLalinKemasan